module.exports = __webpack_public_path__ + "img/py.2c12d782.png";